import React from 'react';
import '../UploadForm.css';
import HighlightHeader from '../../assets/images/brush3.png';

function UploadHeader() {
  return (
    <div className="upload-header">
      <div className="highlight-header-wrapper">
        <h1>Recycle your resume</h1>
        <div className="highlight-header">
          <img src={HighlightHeader} alt="highlighting texture" />
        </div>
      </div>
      <p style={{ margin: '7px 0 20px 0' }}>Find your best  match to a job description's keywords below.</p>
    </div>
  );
}

export default UploadHeader;


